import Swiper, {Navigation, Pagination} from 'swiper';
import {Utils} from '../../common/scripts/utils';

const articleSliderWrapper = Array.from(document.querySelectorAll('.j-article-slider-wrapper'));
const articleHead = document.querySelector('.j-article-head');
const articleTitle = document.querySelector('.j-article-head-title');
const articleDate = document.querySelector('.j-article-date');
const articleSeparator = document.querySelector('.j-article-separator');
const subscribeSection = document.querySelector('.j-subscribe-section');

if (articleSliderWrapper.length) {
    articleSliderWrapper.forEach((wrapper) => {
        const currentSlider = wrapper.querySelector('.j-article-slider');
        const currentPagination = wrapper.querySelector('.j-article-pagination');
        const currentPrev = wrapper.querySelector('.j-article-prev');
        const currentNext = wrapper.querySelector('.j-article-next');

        const options = {
            modules          : [Navigation, Pagination],
            loop             : false,
            speed            : 800,
            spaceBetween     : 0,
            slidesPerView    : 1,
            slidesOffsetAfter: 0,
            pagination       : {
                el  : currentPagination,
                type: 'custom',
                renderCustom(_, current, total) {
                    const newCurrent = current < 10 ? `0${current}` : current;
                    const newTotal = total < 10 ? `0${total}` : total;

                    return `<span class="slider-control__current">${newCurrent}</span>
                               <span class="slider-control__total">/ ${newTotal}</span>`;
                }
            },
            navigation: {
                nextEl: currentNext,
                prevEl: currentPrev
            },
            breakpoints: {
                1280: {
                    allowTouchMove: false
                }
            }
        };

        const slider = new Swiper(currentSlider, options);

        slider.init();
    });
}

const setAbsolute = (item, top) => {
    item.style.position = 'absolute';
    item.style.top = `${top}px`;
};

const resetAbsolute = (item) => {
    item.style = '';
};

const fixedListener = () => {
    if (Utils.getWindowWidth() > 1279.95 && articleHead) {
        window.addEventListener('scroll', () => {
            if (Utils.isInViewport(subscribeSection, 150)) {
                const articleTitleHeight = articleTitle.clientHeight;
                const top = articleSeparator.offsetTop - articleTitleHeight;

                setAbsolute(articleHead, top);

                if (articleDate) {
                    setAbsolute(articleDate, top);
                }
            } else {
                resetAbsolute(articleHead);

                if (articleDate) {
                    resetAbsolute(articleDate);
                }
            }
        });
    }
};

fixedListener();
